import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonContent, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { MetadataService } from 'src/app/services/metadata-service.service';
import { environment } from 'src/environments/environment';
import { ParamServicesService } from '../../services/param-services.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.page.html',
  styleUrls: ['./product-detail.page.scss'],
})
export class ProductDetailPage implements OnInit, OnDestroy {
  @ViewChild('contentProductDetail') contentProductDetail: IonContent;
  @ViewChild('zoomIn') zoomIn: ElementRef<HTMLImageElement>;
  @ViewChild('zoomInContainer') zoomInContainer: ElementRef<HTMLImageElement>;
  @ViewChild('description') description: ElementRef<HTMLDivElement>;

  public uri: any = environment.url;
  public image: string = '';
  public id = this.route.snapshot.paramMap.get('id');
  public isSbp = this.route.snapshot.queryParamMap.get('sbp');
  public media = [];
  public product: any = undefined;
  public showMore = false;
  public showingMore = false;
  public totalDescription: string;
  public type = 1;
  public loaded = false;
  public longDescription = undefined;
  public indexLastText: number = undefined;
  public availableProduct = true;
  public availableProductBranch = true;
  public isSubscription = '1';
  public typeProduct = undefined;
  private _type = undefined;
  private routeObs = new Subscription();
  public url: any = undefined;
  public isService = this.route.snapshot.queryParamMap.get('service');

  constructor(
    private httpSv: HttpService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    public paramSv: ParamServicesService,
    private loginSv: LoginService,
    private navCtrl: NavController,
    private metaDataSv: MetadataService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.getProduct(this.id);
    this.routeObs.add(
      this.paramSv.reload.subscribe(() => {
        this.loaded = false;
        this.product = undefined;
        setTimeout(() => {
          this.getProduct(this.id);
        }, 500);
      })
    );
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.url = window.location.href;
    }

    this.routeObs.add(
      this.paramSv.reload.subscribe(() => {
        this.detectBranch();
      })
    );
  }

  async setOption(ev) {
    await this.contentProductDetail.scrollToTop(400);
    await this.navCtrl.navigateRoot(['product-detail', this.id], {
      queryParams: {
        opId: ev,
      },
    });
    this.getProduct(ev);
  }

  async getProduct(id) {
    this.httpSv.loadingIndicatorSrc.next(true);
    this.isSubscription = this.route.snapshot.queryParamMap.get('sbp');
    this._type = this.isSubscription
      ? 'subscription'
      : this.isService
      ? 'service'
      : 'product';
    let res = undefined;
    if (this.isService) {
      res = await this.httpSv.getProduct(id, 'services');
      this.product = res;
    } else {
      res = await this.httpSv.getProduct(id, this._type);
      this.product = res;
      this.product.visiblePrice = res.price;
      this.product.visiblePromoPrice = res.promotionalPrice;

      this.product.visiblePriceWSale = res.priceWSale;
      this.product.visiblePromotionalPriceWSale = res.promotionalPriceWSale;
    }

    this.media = res.media;
    let img = this.product.coverImages || this.media[0]?.file;
    const opId = Number(this.route.snapshot.queryParamMap.get('opId'));
    const option = this.product?.options?.find((option) => option.id === opId);
    if (option) {
      img = option.media[0].file;
    }

    this.product.image = `${environment.url}/file/${this._type}/${img}`;
    this.product.serverUrl = `${environment.url}`;
    await this.setDataProduct();
    await this.metaDataSv.updateMetadata(
      this.product,
      undefined,
      this.typeProduct
    );
    if (!this.paramSv.domainName) {
      this.routeObs.add(
        this.paramSv.emitImagesObs.subscribe((item) => {
          if (item === 'finish') {
            this.detectBranch();
          }
        })
      );
    } else {
      this.detectBranch();
    }
    this.httpSv.loadingIndicatorSrc.next(false);
  }

  detectBranch() {
    if (this.loginSv.branchContactId && this.product) {
      const existBranch = this.product?.inventory?.find(
        (x: any) => x.branchContactId === this.loginSv.branchContactId
      );
      if (
        !existBranch ||
        (this.loginSv.branchContactId &&
          this.paramSv.dispatch?.branch &&
          existBranch?.existence === 0)
      ) {
        this.availableProductBranch = false;
      } else {
        this.availableProductBranch = true;
      }
    }
  }

  ngOnDestroy(): void {
    this.routeObs.unsubscribe();
  }

  back() {
    this.navCtrl.back();
  }

  async setDataProduct() {
    try {
      if ('inscriptionPrice' in this.product) {
        this.typeProduct = 'subscription';
      } else if (this.isService) {
        this.typeProduct = 'service';
      } else {
        this.typeProduct = 'product';
      }
      if (this.product.deletedAt || this.product.isActive === 0) {
        this.availableProduct = false;
      }

      if (this.paramSv.buyControl) {
        this.setControl();
      } else {
        if (this.paramSv.buttons && !this.paramSv.buyControl) {
          this.setControl();
        } else {
          const param = this.paramSv.emitImagesObs.subscribe((item: any) => {
            if (item === 'finish') {
              if (!this.paramSv.buyControl) {
                this.setControl();
              }
              this.loaded = true;
              setTimeout(() => {
                this.setDescription();
              });
              param.unsubscribe();
            } else if (item.name === 'buyControl') {
              if (this.product.relations && this.product?.relations?.length) {
                this.product.relations = this.paramSv.fixProducts(
                  this.product.relations,
                  this.loginSv.user
                );
              }
            } else if (item.name === 'detailStyle') {
              this.type = this.paramSv.detailStyle;
            }
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  setControl() {
    if (this.paramSv.buyControl) {
      this.product.relations = this.paramSv.fixProducts(
        this.product.relations,
        this.loginSv.user
      );
    }
    this.type = this.paramSv.detailStyle || 1;
    this.loaded = true;
    setTimeout(() => {
      this.setDescription();
    });
  }

  setDescription() {
    const longDescription = this.product?.longDescription?.toLowerCase();
    if (
      this.description &&
      this.product.longDescription &&
      !longDescription.includes('undefined') &&
      !longDescription.includes('null')
    ) {
      this.longDescription = true;
      this.description.nativeElement.innerHTML = this.product.longDescription;
      if (this.paramSv?.buyControl?.openDescription) {
        return true;
      }
      const element = this.description.nativeElement;
      const totalLength = element?.innerHTML?.length;
      if (totalLength > 500) {
        this.showMore = true;
        this.totalDescription = element.innerHTML;
        let indexText: string = element.textContent.slice(0, 500);
        indexText = indexText.replace(/\n/g, ' ');
        indexText = indexText.trim();
        let splitedText: any[] = indexText.split(' ');
        splitedText = splitedText.filter((item) => {
          if (item !== '' && item !== ' ') {
            return item;
          }
        });
        splitedText = splitedText.reverse();
        for (const word of splitedText) {
          this.indexLastText = element.innerHTML.lastIndexOf(word);
          if (this.indexLastText !== -1) {
            break;
          }
        }
        element.innerHTML = `${element.innerHTML.slice(
          0,
          this.indexLastText
        )}...`;
      }
    }
  }

  showMoreBtn() {
    const element = this.description.nativeElement;
    element.innerHTML = !this.showingMore
      ? this.totalDescription
      : `${element.innerHTML.slice(0, this.indexLastText)}...`;
    this.showingMore = !this.showingMore;
  }

  onZoom(data) {
    let ratio = 6;
    let x = 2.35;
    let y = 1.75;
    let scale = 2.5;
    if (document.body.offsetWidth <= 1280) {
      ratio = 5;
      x = 2.8;
    }
    if (document.body.offsetWidth <= 1024) {
      scale = 2;
      ratio = 4;
      x = 4.75;
      y = 2.25;
    }
    const img = data.img;
    this.image = `${this.uri}/file/${this.typeProduct}/${img}`;
    this.renderer.setStyle(
      this.zoomIn.nativeElement,
      'transform',
      `scale(${scale})`
    );
    this.renderer.setStyle(
      this.zoomIn.nativeElement,
      'transform-origin',
      `${data.xx * x}px ${data.yy * y}px`
    );
    this.renderer.setStyle(
      this.zoomInContainer.nativeElement,
      'height',
      `${data.h2 * ratio}px`
    );
    this.renderer.setStyle(
      this.zoomInContainer.nativeElement,
      'width',
      `${data.w2 * ratio}px`
    );
    this.renderer.setStyle(
      this.zoomInContainer.nativeElement,
      'display',
      `block`
    );
  }

  offZoom() {
    this.image = '';
    this.renderer.setStyle(
      this.zoomInContainer.nativeElement,
      'display',
      `none`
    );
  }
}
